import { render, staticRenderFns } from "./outer-casing.vue?vue&type=template&id=67884002"
var script = {}
import style0 from "./outer-casing.vue?vue&type=style&index=0&id=67884002&prod&lang=stylus"
import style1 from "./outer-casing.vue?vue&type=style&index=1&id=67884002&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports